export const DEFAULT_LOCATION_OPTION = 'near-me';
export const LOCATION_OPTIONS = [
    { value: 'near-me', label: 'Near me' },
    { value: 'all', label: 'All in country' },
];
export const parseLocationOption = (value) => {
    if (value === 'near-me' || value === 'all') {
        return value;
    }
    return null;
};
//# sourceMappingURL=location-buckets.js.map